import { render } from "./FaultPage.vue?vue&type=template&id=60db650a"
import script from "./FaultPage.vue?vue&type=script&lang=js"
export * from "./FaultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/Battery/FaultPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60db650a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60db650a', __exports__)) {
    api.reload('60db650a', __exports__)
  }
  
  module.hot.accept("./FaultPage.vue?vue&type=template&id=60db650a", () => {
    api.rerender('60db650a', render)
  })

}


export default __exports__